"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es.function.name.js");
var _ArrowLine = _interopRequireDefault(require("./ArrowLine.vue"));
var _AddNode = _interopRequireDefault(require("./AddNode.vue"));
var _emit = _interopRequireDefault(require("../emit"));
var _constant = require("../constant");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * @Author: zzy
 * @Date: 2022-12-15 09:33:21
 * @Desc: 普通节点
 */
var _default2 = exports.default = {
  name: 'SFCNormalNode',
  components: (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _ArrowLine.default.name, _ArrowLine.default), _AddNode.default.name, _AddNode.default),
  props: {
    nodeList: {
      type: [Array, null],
      default: function _default() {
        return null;
      }
    },
    childrenList: {
      type: [Array, null],
      default: function _default() {
        return null;
      }
    },
    data: {
      type: Object,
      default: null
    },
    belongConditionNodeData: {
      type: Object,
      default: null
    },
    isMouseEnter: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: _constant.store.readonly,
      vertical: _constant.store.vertical,
      showDeleteBtn: false
    };
  },
  methods: {
    onContentMouseenter: function onContentMouseenter() {
      this.showDeleteBtn = true;
    },
    onContentMouseleave: function onContentMouseleave() {
      this.showDeleteBtn = false;
    },
    onContentClick: function onContentClick() {
      _emit.default.emit('node-content-click', this.data, this.nodeList);
    },
    onDeleteNode: function onDeleteNode() {
      _emit.default.emit('delete-node-click', this.nodeList, this.childrenList, this.belongConditionNodeData, this.data);
    }
  }
};